import { FC } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { ButtonProps } from '@/shared/uikit/Button';
import { Button as AntButton } from '@/shared/uikit/Button';
import { Icon } from '@/shared/uikit/Icon';

export const AiButton: FC<ButtonProps> = ({ children, ...props }) => (
  <StyledButton className="truncate" icon={<Icon name="sparkle" size="s20" />} {...props}>
    <ButtonContent>{children}</ButtonContent>
  </StyledButton>
);

const StyledButton = styled(AntButton)`
  &&& {
    --bgColor: #4b1b9f;
    height: 48px;
    background: var(--bgColor);
    border: none;
    font-weight: 600;
    font-size: 14px;
    padding: 12px 16px;
    gap: 4px;
    position: relative;
    overflow: hidden;

    .ant-btn-icon,
    & > & {
      position: relative;
    }

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 32px;
      bottom: -40%;
      background: #fb9041;
      filter: blur(16px);
    }

    &:hover {
      background: var(--bgColor) !important;
    }

    &:disabled {
      opacity: 0.5;
      color: ${COLORS.white};
    }
  }
`;

const ButtonContent = styled.div`
  position: relative;
`;
